import React, { Fragment } from "react"
import { GitHub } from "./Icons"
import Field from "./Field"

const LinkStyle = {
    backgroundColor: 'var(--mdGray)',
    borderRadius: 15,
    display: 'flex',
    placeItems: 'center',
    padding: "5px 10px",
    width: 'fit-content',
    placeSelf: 'center',
    gap: 5
}
function GitHubLink({ user, link, projectId }) {
    return (
        <Fragment>
            {user ?
                <div style={LinkStyle}>
                    <GitHub />
                    <Field
                        color="white"
                        type='h4'
                        value={link?.name || "Link GitHub"}
                        fieldPath={`projects/${projectId}/github`}
                        inline
                        github
                    />
                </div>
                :
                link && <a
                    style={LinkStyle}
                    className='popUp'
                    href={link?.link}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <GitHub size={20} />
                    <p className="h4" style={{ color: 'white' }}>{link?.name}</p>
                </a>
            }
        </Fragment >
    )
}

export default GitHubLink